<app-question-stepper
  [noOfSteps]="noOfSteps"
  [currentStepNumber]="currentStepNumber"
></app-question-stepper>
<h1 class="nes-h2 nes-mb-5" >
  {{ question.title | translate }}
</h1>
<p class="nes-mb-10">
  {{ question.subTitle | translate }}
</p>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <ng-container *ngFor="let field of question.fields">
    <div [ngSwitch]="field.type">
      <div *ngSwitchCase="'input'" class="nes-mb-6">
        <nes-input

          [nesId]="field.name"
          [required]="field.required"
          nesFormControl
          [value]="form.get(field.name)?.value"
          [label]="field.label ? (field.label | translate) : ''"
          [helpText]="field.subLabel ? (field.subLabel | translate) : ''"
          [formControlName]="field.name"
        >
        </nes-input>
        <nes-error-message *ngIf="hasError(field.name, 'required')">
          {{ "VALIDATION.INPUT.REQUIRED" | translate }}
        </nes-error-message>
      </div>

      <div *ngSwitchCase="'radio'">
        <nes-selectable-group
          (nesOnGroupChange)="onSelectableRadioChange($event)"
          nes-id="nes-selectable-group"
          label="nes-selectable-group"
          class="nes-mb-6"
        >
          <nes-heading class="nes-mb-3" size="400">
            {{ field.label ? (field.label | translate) : "" }}
          </nes-heading>

          <div *ngFor="let option of field.options; let i = index">
            <nes-selectable-radio
              class="nes-mb-3"
              required
              nesFormControl
              [nesId]="option.value"
              [name]="field.name"
              [label]="option.label | translate"
              [formControlName]="field.name"
              [checked]="form.get(field.name)?.value === option.value"
              [value]="option.value"
            >
              <div slot="header">
                <nes-text color="text-default" weight="bold">
                  {{ option.label | translate }}
                </nes-text>
              </div>
            </nes-selectable-radio>
          </div>
          <nes-error-message
            *ngIf="hasError(field.name, 'required')"
            class="error-message"
          >
            {{ "VALIDATION.RADIO.REQUIRED" | translate }}
          </nes-error-message>
        </nes-selectable-group>
      </div>

      <div *ngSwitchCase="'checkbox'">
        <div class="nes-mb-6">
          <nes-heading class="nes-mb-3" size="400">
            {{ field.label ? (field.label | translate) : "" }}
          </nes-heading>
          <div *ngFor="let option of field.options">
            <nes-selectable-checkbox
              class="nes-mb-3"
              nesFormControl
              [nesId]="field.name + '_' + option.value"
              [name]="field.name"
              [label]="option.label | translate"
              hiddenLabel
              [value]="option.value"
              [checked]="form.get(field.name)?.value?.includes(option.value)"
              (nesOnClick)="onSelectableCheckboxChange($event)"
            >
              <div slot="header">
                <h3 class="nes-label nes-label--lg nes-label--strong">
                  {{ option.label | translate }}
                </h3>
              </div>
            </nes-selectable-checkbox>
          </div>
        </div>
        <div *ngIf="hasError(field.name, 'required')" class="error-message">
          {{ "VALIDATION.REQUIRED_RADIO_OR_CHECKBOX" | translate }}
        </div>
      </div>
    </div>
  </ng-container>
  <nes-button
    class="nes-mt-6"
    (nesOnClick)="onSubmit()"
    [variant]="question.button.variant | translate"
  >
    {{
      flowIsComplete
        ? ("WIZARD.BACK_TO_ADVICE" | translate)
        : (question.button.label | translate)
    }}</nes-button
  >
</form>
